import { FC, SVGProps } from 'react';

const UserIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#7a7a7a', size = 16, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M3.69391 13.3331C3.69391 11.9274 4.803 10.1771 7.99977 10.1771C11.1959 10.1771 12.305 11.9146 12.305 13.321"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7502 5.4171C10.7502 6.93619 9.51888 8.16752 7.99975 8.16752C6.48128 8.16752 5.24994 6.93619 5.24994 5.4171C5.24994 3.89799 6.48128 2.66666 7.99975 2.66666C9.51888 2.66666 10.7502 3.89799 10.7502 5.4171Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UserIcon;
